import React, { type ReactNode } from 'react';
import { type ClassValue } from 'clsx';
import type { WindowDimensions } from '@/common/types/global.types';
import { cn } from '@/lib/utils';

interface PageMaxLayoutProps {
  isMobile: boolean;
  children: ReactNode;
  dimensions: WindowDimensions;
  className?: ClassValue;
  childClassName?: ClassValue;
  style?: React.CSSProperties;
  readonly?: boolean;
}

const PageMaxLayout: React.FC<PageMaxLayoutProps> = ({
  className,
  childClassName,
  dimensions,
  isMobile,
  readonly = true,
  children,
  style,
}) => {
  return (
    <div
      className={cn(
        'bg-background @container flex h-full w-full flex-col items-center overflow-y-auto transition-none',
        isMobile ? 'px-1 pt-4 pb-12' : 'px-3 pt-4 pb-12',
        className
      )}
      style={{
        ...style,
        maxHeight: readonly
          ? 'unset'
          : dimensions?.height
            ? `${dimensions.height - 120}px`
            : '100%',
        transition: 'none',
      }}>
      <div
        className={cn(
          'flex h-fit w-full max-w-[1440px] flex-col items-center justify-start gap-4 p-4 md:py-6',
          childClassName
        )}>
        {children}
      </div>
      {!readonly && <div className='mt-10 h-6 w-full' aria-hidden='true' />}
    </div>
  );
};

export default PageMaxLayout;
